import React, { useState, useEffect } from "react";
import Modal from "../../../../components/ui/Modal";
import Button from "../../../../components/ui/Button";
import { v4 as uuidv4 } from "uuid";

const CreateDonationCampaignModal = ({
  isOpen,
  onClose,
  onSave,
  campaignToEdit,
}) => {
  const [title, setTitle] = useState("");
  const [beneficiary, setBeneficiary] = useState("");
  const [goalETB, setGoalETB] = useState("");

  useEffect(() => {
    if (isOpen) {
      setTitle("");
      setBeneficiary("");
      setGoalETB("");
    }
  }, [isOpen]);

  const handleSubmit = () => {
    if (!title || !beneficiary || !goalETB) {
      alert("Please fill out all fields.");
      return;
    }

    const newCampaignData = {
      id: `DC-GIGI-${uuidv4().slice(0, 4)}`,
      title,
      beneficiary,
      goalETB: parseFloat(goalETB),
      raisedETB: 0,
      status: "Pending",
      isCreatorSubmitted: true,
    };
    onSave(newCampaignData);
    onClose();
  };

  return (
    <Modal
      title="Submit a Cause for Approval"
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-slate-700">
            Cause / Campaign Title
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g., Addis Animal Shelter Drive"
            className="mt-1 block w-full rounded-md border-slate-300 shadow-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700">
            Beneficiary
          </label>
          <input
            type="text"
            value={beneficiary}
            onChange={(e) => setBeneficiary(e.target.value)}
            placeholder="e.g., City Animal Welfare Group"
            className="mt-1 block w-full rounded-md border-slate-300 shadow-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700">
            Funding Goal (ETB)
          </label>
          <input
            type="number"
            value={goalETB}
            onChange={(e) => setGoalETB(e.target.value)}
            placeholder="e.g., 50000"
            className="mt-1 block w-full rounded-md border-slate-300 shadow-sm"
          />
        </div>
        {/* ✨ FIX: The informational text is now correct and clear ✨ */}
        <div className="p-3 bg-slate-50 rounded-md text-sm text-slate-600">
          <p>
            <strong>Next Steps:</strong> Your submission will be sent to the
            Adnaki team for review. The platform is responsible for vetting the
            cause and setting up all necessary payment systems. You will be
            notified once it is approved and live on your page.
          </p>
        </div>
      </div>
      <div className="mt-6 flex justify-end space-x-2">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Submit for Review
        </Button>
      </div>
    </Modal>
  );
};

export default CreateDonationCampaignModal;
